import { Paper, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(1),
        marginBottom: theme.spacing(2)
    }
}));

const CharacterStats = () => {
    const classes = useStyles();
    const [stats, setStats] = useState(null);
    const { characterKills } = useSelector(state => state.uniqueKillsData);

    useEffect(() => {
        let existingIds = [];
        let totalUniqueKills = 0;
        let totalKills = 0;
        let totalKilledValue = 0;
        let totalPoints = 0;
        let soloKills = 0;

        Object.entries(characterKills).forEach(([characterId, kills]) => {
            totalKills += kills.length;
            kills.forEach(kill => {
                if (existingIds.indexOf(kill.id) > -1) return;
                existingIds.push(kill.id);

                if (kill.solo) soloKills += 1;
                totalUniqueKills += 1;
                totalPoints += kill.points;
                totalKilledValue += kill.value;
            });
        });

        setStats({
            totalUniqueKills,
            totalKills,
            totalPoints,
            totalKilledValue,
            soloKills
        });
    }, [characterKills]);

    if (!stats) return null;
    if (stats.totalKills === 0) return null;

    const multiboxPercentage =
        stats.totalKills > 0 ? ((stats.totalKills - stats.totalUniqueKills) / stats.totalKills) * 100 : 0;

    return (
        <Paper className={classes.paper}>
            <Typography>
                Total Kills: {stats.totalUniqueKills.toLocaleString(undefined, { maximumFractionDigits: 0 })}
            </Typography>
            <Tooltip title={'The percentage of kills where more than 2 or more of your characters got on the kill.'}>
                <Typography>Multibox Percentage: {multiboxPercentage.toFixed(2)}%</Typography>
            </Tooltip>
            <Typography>
                Total destroyed: {stats.totalKilledValue.toLocaleString(undefined, { maximumFractionDigits: 0 })} ISK
            </Typography>
            <Typography>
                Total points: {stats.totalPoints.toLocaleString(undefined, { maximumFractionDigits: 0 })}
            </Typography>
            <Typography>
                Solo kills: {stats.soloKills.toLocaleString(undefined, { maximumFractionDigits: 0 })}
            </Typography>
        </Paper>
    );
};

export default CharacterStats;
